export default __webpack_public_path__ + "static/media/home-qualification11.ac5102a1.png";